// import axiosInstance from "../app/axios";
import axios from "axios";
import { PeriodType } from "../components/reports/dashboard";
import { SaveScrapEmailConfig, ScrapEmailConfig } from "../components/reports/scrap-emails/EmailConfigModal";
import { SaveScrapInvalidDomain, ScrapInvalidDomain } from "../components/reports/scrap-emails/InvalidDomainsModal";
import { selectCurrentAdminToken } from "../utils/helpers/selectorHelper";

const apiUrl = process.env.REACT_APP_API_URL;
let globalAbortController: AbortController | null = null;

const axiosInstance = axios.create({
  baseURL: apiUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = selectCurrentAdminToken();
    if (token) config.headers!.auth = token;
    if (!globalAbortController) globalAbortController = new AbortController();
    return config;
  },
  (error) => {
    // notification.error({ message: error, placement: "bottom" });
    console.log('error', error)
    Promise.reject(error);
  },
);


export const getCompaniesWithInteractionsReport = async (startDate: string, endDate: string) => {
  const result = await axiosInstance.get(`reports/companies-with-interactions?startDate=${startDate}&endDate=${endDate}`);
  return result.data;
};

export const getSalesReport = async (startDate: string, endDate: string, periodType: PeriodType, companyId: string) => {
  const result = await axiosInstance.get(`reports/sales?startDate=${startDate}&endDate=${endDate}&periodType=${periodType}&companyId=${companyId}`);
  return result.data;
};

export const getUsersReport = async (startDate: string, endDate: string, periodType: PeriodType, companyId: string) => {
  const result = await axiosInstance.get(`reports/users?startDate=${startDate}&endDate=${endDate}&periodType=${periodType}&companyId=${companyId}`);
  return result.data;
};

export const getTripsReport = async (startDate: string, endDate: string, periodType: PeriodType, companyId: string) => {
  const result = await axiosInstance.get(`reports/trips?startDate=${startDate}&endDate=${endDate}&periodType=${periodType}&companyId=${companyId}`);
  return result.data;
};

export const getScrapInvalidDomains = async () => {
  const result = await axiosInstance.get(`scrap-email/invalid-domains`);
  return result.data;
};

export const saveScrapInvalidDomains = async (data: ScrapInvalidDomain | SaveScrapInvalidDomain) => {
  const result = await axiosInstance.post(`scrap-email/invalid-domains`, data);
  console.log('result', result)
  return result?.data;
};

export const getScrapEmailsConfigDomains = async () => {
  const result = await axiosInstance.get(`scrap-email/config`);
  return result.data;
};

export const saveScrapEmailsConfigDomains = async (data: SaveScrapEmailConfig | ScrapEmailConfig) => {
  const result = await axiosInstance.post(`scrap-email/config`, data);
  return result.data;
};

export const getScrapedEmails = async (page: number, take: number, startDate: string, endDate: string) => {
  const query = `page=${page}&take=${take}&startDate=${startDate}&endDate=${endDate}`
  const result = await axiosInstance.get(`scrap-email/scraped-emails?${query}`);
  return result.data;
};

export const getTripsParkingReport = async (page: number, take: number, startDate: string, endDate: string, status: string) => {
  const query = `page=${page}&take=${take}&startDate=${startDate}&endDate=${endDate}&status=${status}`
  const result = await axiosInstance.get(`trip/parking-bill?${query}`);
  return result.data;
};

export const updateTripParkingStatus = async (id: number, status: string, comment: string) => {
  const result = await axiosInstance.patch(`trip/parking-bill/status`, {id, status, comment});
  return result.data;
};

// Trip Request Analytics
export const getTripRequestAnalyticsStats = async (startDate: string, endDate: string, companyId?: string) => {
  let query = `analytics/trip-request/stats?startDate=${startDate}&endDate=${endDate}`;
  if (companyId) query += `&companyId=${companyId}`;
  const result = await axiosInstance.get(query);
  return result.data;
};

export const getAnalyticsCompanyBreakdown = async (startDate: string, endDate: string) => {
  const result = await axiosInstance.get(`analytics/trip-request/companies?startDate=${startDate}&endDate=${endDate}`);
  return result.data;
};

export const getAnalyticsUserDetail = async (adminId: number, startDate: string, endDate: string) => {
  const result = await axiosInstance.get(`analytics/trip-request/users/${adminId}?startDate=${startDate}&endDate=${endDate}`);
  return result.data;
};

export const getAnalyticsConversionTrend = async (startDate: string, endDate: string, periodType: string) => {
  const result = await axiosInstance.get(`analytics/trip-request/conversion-trend?startDate=${startDate}&endDate=${endDate}&periodType=${periodType}`);
  return result.data;
};

export const sendFollowUpEmail = async (recipientEmail: string, subject: string, body: string) => {
  const result = await axiosInstance.post(`analytics/trip-request/send-followup`, { recipientEmail, subject, body });
  return result.data;
};

